import React from "react";

/* Shared glyphs for the two actions used across every product page/card:
   adding to cart and downloading a datasheet. Keeping one definition means
   both icons look identical everywhere instead of drifting per page. */

export const CartIcon = ({ size = 18, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9" cy="21" r="1.4" fill="currentColor" />
    <circle cx="20" cy="21" r="1.4" fill="currentColor" />
    <circle cx="19.5" cy="4" r="4" fill="white" />
    <path
      d="M19.5 2.3v3.4M17.8 4h3.4"
      stroke="#059669"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const DownloadIcon = ({ size = 18, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 2h8l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M14 2v4h4"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M12 10v6m0 0-2.3-2.3M12 16l2.3-2.3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
